
import qdapHomePageQuery from '@/apollo/queries/qdap/qdapHomePage';
import pageMeta from '~/mixins/pageMeta.js';
export default {
    name: "QdapHome",
    mixins: [pageMeta],
    props: {

        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: 0,
            pageData: null,
        }
    },

    apollo: {
        $loadingKey: 'loading',
        pageData: {
            prefetch: true,
            query: qdapHomePageQuery,
            variables() {
                return { currentlocale: this.$normalizeLocale(this.$i18n.locale), year: `${this.$route.params.year}` };
            },
            update(data) {
                return this.$normalizeStrapi(data?.qdapMalls?.data[0]);
            },
            result({ data }) {
                if(!data || !data?.qdapMalls?.data.length){
                    this.$router?.push(
                    {
                        name: "qdap-year___" + this.$i18n.locale,
                        params: {
                        year: '2025',
                        },
                    }
                    )
                }
            },
        },
    },


    mounted() {
    },
    methods: {
    },
}
